import React from "react";

import { Button, Group } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";

interface FilterDropdownButtonProps {
  onClick?: () => void;
  activeBackground?: boolean;
  children: React.ReactNode;
}

export function FilterDropdownButton(props: FilterDropdownButtonProps): JSX.Element {
  return (
    <Button
      variant="secondary"
      onClick={props.onClick}
      sx={(theme) => ({
        borderRadius: "60px",
        justifyContent: "center",
        alignItems: "center",
        padding: "4px 12px",
        backgroundColor: props.activeBackground ? theme.colors.gray[2] : "inherit",
      })}
    >
      <Group wrap="nowrap">
        {props.children}
        <IconChevronDown size={10} />
      </Group>
    </Button>
  );
}
